
<div class="container-fluid">
  <div class="card">

    <!-- Header -->
    <div class="card-header nocollapse">
      Manage Users
    </div>

    <!-- Action buttons — NgbModal (Settings pattern) -->
    <div class="page-attributes p-1" style="margin-left:10px; margin-top:0;">
      <button class="btn btn-sm btn-primary btn-action"
              (click)="openCreateUserModal()">
        <i class="fa fa-user-plus"></i> Create New User
      </button>

      <button *ngIf="tmpWorkspaceId === '1'"
              class="btn btn-sm btn-primary btn-action"
              (click)="openBulkUploadModal()">
        <i class="fa fa-users"></i> Bulk User Upload
      </button>

      <button class="btn btn-sm btn-primary btn-action"
              (click)="openNewsletterModal()">
        <i class="fa fa-send"></i> Send Newsletter
      </button>

      <button class="btn btn-sm btn-primary btn-action"
              (click)="openOktaUserModal()">
        <i class="fa fa-user-plus"></i> Create Okta User
      </button>

      <button class="btn btn-sm btn-primary btn-action"
              (click)="getMasterUserList()">
        <i class="fa fa-file-excel-o"></i> Export Master User List
      </button>
    </div>

    <!-- Okta status message (*ngIf on property — replaces DOM getElementById) -->
    <div *ngIf="successOrFailureOktaMessage !== ''"
         class="card-header nocollapse bg-info col-md-12 msg-container"
         style="color: #326295;">
      <b>{{ successOrFailureOktaMessage }}</b>
    </div>

    <!-- General status message -->
    <div *ngIf="successOrFailureMessage !== ''"
         class="card-header nocollapse bg-info col-md-12 msg-container">
      <i class="fa fa-info-circle fa-lg mt-1" style="color: #326295;"></i>
      <span>{{ successOrFailureMessage }}</span>
    </div>

    <!-- IsgGridComponent (Settings pattern — replaces ag-grid-angular directly) -->
    <isg-grid [rowData]="usernewlist"
              [columnDefs]="columnDefs"
              [defaultColDef]="defaultColDef"
              [config]="gridConfig"
              (gridReady)="onGridReady($event)">
    </isg-grid>

  </div>
</div>

<!-- ── Create / Edit User Modal ──────────────────────────── -->
<ng-template #userModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ currentUserId > 0 ? 'Edit User' : 'Create New User' }}</h5>
    <button type="button" class="btn-close" aria-label="Close"
            (click)="modal.dismiss(); onClose()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="userForm">
      <small class="form-text text-danger"
             *ngIf="userForm.invalid && userForm.touched">
        Please enter all required fields.
      </small>

      <div class="row mb-2">
        <label class="col-md-4 col-form-label">First Name <span class="text-danger">*</span></label>
        <div class="col-md-8">
          <input type="text" maxlength="100" formControlName="firstName"
                 class="form-control form-control-sm" />
          <small class="text-danger"
                 *ngIf="userForm.get('firstName')?.invalid && userForm.get('firstName')?.touched">
            First Name is required.
          </small>
        </div>
      </div>

      <div class="row mb-2">
        <label class="col-md-4 col-form-label">Middle Name</label>
        <div class="col-md-8">
          <input type="text" maxlength="100" formControlName="middleName"
                 class="form-control form-control-sm" />
        </div>
      </div>

      <div class="row mb-2">
        <label class="col-md-4 col-form-label">Last Name</label>
        <div class="col-md-8">
          <input type="text" maxlength="100" formControlName="lastName"
                 class="form-control form-control-sm" />
        </div>
      </div>

      <div class="row mb-2">
        <label class="col-md-4 col-form-label">Email <span class="text-danger">*</span></label>
        <div class="col-md-8">
          <input type="email" maxlength="150" formControlName="userEmail"
                 [attr.disabled]="currentUserId > 0 ? '' : null"
                 class="form-control form-control-sm" />
          <div *ngIf="userForm.get('userEmail')?.invalid && userForm.get('userEmail')?.touched">
            <small class="text-danger"
                   *ngIf="userForm.get('userEmail')?.hasError('required') || userForm.get('userEmail')?.hasError('email')">
              Please enter a valid email address.
            </small>
            <small class="text-danger"
                   *ngIf="userForm.get('userEmail')?.hasError('userExists')">
              Username already exists.
            </small>
          </div>
        </div>
      </div>

      <div class="row mb-2">
        <label class="col-md-4 col-form-label">Role Name <span class="text-danger">*</span></label>
        <div class="col-md-8">
          <select formControlName="roleId" class="form-select form-select-sm">
            <option *ngFor="let r of roles" [ngValue]="r.roleId">{{ r.roleName }}</option>
          </select>
        </div>
      </div>

      <div class="row mb-2">
        <label class="col-md-4 col-form-label">Provider Company <span class="text-danger">*</span></label>
        <div class="col-md-8">
          <select formControlName="companyId" class="form-select form-select-sm">
            <option *ngFor="let c of company" [ngValue]="c.companyId">{{ c.companyName }}</option>
          </select>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-md-4"></div>
        <div class="col-md-8 d-flex align-items-center gap-2">
          <input type="checkbox" id="notifyMe" formControlName="notifyMe" class="form-check-input" />
          <label for="notifyMe" class="form-check-label">Notify</label>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-modal"
            (click)="modal.dismiss(); onClose()">
      <i class="fa fa-times"></i> Close
    </button>
    <button type="button" class="btn btn-primary btn-modal"
            [disabled]="userForm.invalid"
            (click)="modal.close(); saveUserList()">
      <i class="fa fa-save"></i> Save
    </button>
  </div>
</ng-template>

<!-- ── Delete Confirmation Modal ─────────────────────────── -->
<ng-template #deleteUserModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Delete Confirmation</h5>
    <button type="button" class="btn-close" aria-label="Close"
            (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p>Are you sure you want to delete this user?</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-modal"
            (click)="modal.dismiss()">
      <i class="fa fa-times"></i> Close
    </button>
    <button type="button" class="btn btn-danger btn-modal"
            (click)="modal.close(); deleteUser()">
      <i class="fa fa-trash"></i> Delete
    </button>
  </div>
</ng-template>

<!-- ── Bulk User Upload Modal ────────────────────────────── -->
<ng-template #bulkUploadModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Bulk User Upload</h5>
    <button type="button" class="btn-close" aria-label="Close"
            (click)="modal.dismiss(); onCloseBulkUpload()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="bulkUserUploadForm">
      <div class="row mb-2">
        <label class="col-md-4 col-form-label">Service Line <span class="text-danger">*</span></label>
        <div class="col-md-8">
          <select formControlName="serviceLineId" class="form-select form-select-sm"
                  (change)="onServiceLineChange()">
            <option *ngFor="let sl of serviceLines" [ngValue]="sl.serviceLineId">
              {{ sl.serviceLineName }}
            </option>
          </select>
        </div>
      </div>
      <div class="row mb-2">
        <label class="col-md-4 col-form-label">Survey <span class="text-danger">*</span></label>
        <div class="col-md-8">
          <select formControlName="surveyId" class="form-select form-select-sm">
            <option *ngFor="let sv of surveys" [ngValue]="sv.surveyId">{{ sv.surveyName }}</option>
          </select>
        </div>
      </div>
      <div class="row mb-2">
        <label class="col-md-4 col-form-label">Select File <span class="text-danger">*</span></label>
        <div class="col-md-8">
          <input type="file" formControlName="fileControl" class="form-control form-control-sm"
                 (change)="incomingFile($event)" accept=".xlsx,.xls" />
          <small>{{ fileName }}</small>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-4"></div>
        <div class="col-md-8 d-flex align-items-center gap-2">
          <input type="checkbox" id="excludeExisting" formControlName="excludeExistingUsers"
                 class="form-check-input" />
          <label for="excludeExisting" class="form-check-label">Exclude Existing Users</label>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-modal"
            (click)="modal.dismiss(); onCloseBulkUpload()">
      <i class="fa fa-times"></i> Close
    </button>
    <button type="button" class="btn btn-primary btn-modal"
            [disabled]="bulkUserUploadForm.invalid"
            (click)="modal.close(); saveBulkUser()">
      <i class="fa fa-upload"></i> Upload
    </button>
  </div>
</ng-template>

<!-- ── Send Newsletter Modal ─────────────────────────────── -->
<ng-template #newsletterModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Send Newsletter</h5>
    <button type="button" class="btn-close" aria-label="Close"
            (click)="modal.dismiss(); onCloseNewsletter()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="newsLetterUploadForm">
      <div class="row mb-2">
        <label class="col-md-2 col-form-label">Subject <span class="text-danger">*</span></label>
        <div class="col-md-10">
          <input type="text" maxlength="100" formControlName="subject"
                 class="form-control form-control-sm" />
        </div>
      </div>
      <div class="row mb-2">
        <label class="col-md-2 col-form-label">Select File <span class="text-danger">*</span></label>
        <div class="col-md-10">
          <input type="file" class="form-control form-control-sm"
                 formControlName="fileControlnewLetter"
                 accept="application/pdf"
                 (change)="selectFile($event, newsLetterUploadForm)" />
        </div>
      </div>
      <!-- CKEditor: keep existing ck-editor tag — upgrade to CKEditor 5 separately -->
      <div class="col-md-auto">
        <ck-editor name="emailtemplate"
                   formControlName="emailtemplate"
                   skin="moono-lisa"
                   language="en"
                   [fullPage]="true">
        </ck-editor>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-modal"
            (click)="modal.dismiss(); onCloseNewsletter()">
      <i class="fa fa-times"></i> Close
    </button>
    <button type="button" class="btn btn-primary btn-modal"
            [disabled]="newsLetterUploadForm.invalid"
            (click)="modal.close(); sendNewLetters(newsLetterUploadForm)">
      <i class="fa fa-send"></i> Send
    </button>
  </div>
</ng-template>

<!-- ── Create Okta User Modal ────────────────────────────── -->
<ng-template #oktaUserModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Create New Okta User</h5>
    <button type="button" class="btn-close" aria-label="Close"
            (click)="modal.dismiss(); onClose()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="oktaUserForm">
      <div class="row mb-2">
        <label class="col-md-4 col-form-label">Provider Company <span class="text-danger">*</span></label>
        <div class="col-md-8">
          <select formControlName="oktaCompanyId" class="form-select form-select-sm"
                  (change)="onCompanyChange()">
            <option *ngFor="let c of company" [ngValue]="c.companyId">{{ c.companyName }}</option>
          </select>
        </div>
      </div>
      <div class="row mb-2">
        <label class="col-md-4 col-form-label">User Email <span class="text-danger">*</span></label>
        <div class="col-md-8">
          <select formControlName="userEmail" class="form-select form-select-sm">
            <option value="">--Select--</option>
            <option *ngFor="let u of providerUserList" [ngValue]="u.userId">{{ u.userEmail }}</option>
          </select>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-modal"
            (click)="modal.dismiss(); onClose()">
      <i class="fa fa-times"></i> Close
    </button>
    <button type="button" class="btn btn-primary btn-modal"
            [disabled]="oktaUserForm.invalid"
            (click)="modal.close(); saveOktaUser()">
      <i class="fa fa-save"></i> Save
    </button>
  </div>
</ng-template>
